import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Esto funciona si tengo SOP, endometriosis o estoy en menopausia?',
    a: 'Sí. El protocolo trabaja con tu ciclo hormonal actual. El programa incluye adaptaciones para cada condición.'
  }, {
    q: '¿Necesito ser experta en nutrición o fitness?',
    a: 'No. Todo está explicado en lenguaje simple con pasos concretos. Si podés leer esta página, podés aplicar el protocolo.'
  }, {
    q: '¿Qué pasa si mi ciclo es irregular?',
    a: 'El programa incluye una sección especial para sincronizar el protocolo con la luna o con un ciclo artificial de 28 días.'
  }, {
    q: '¿Cuándo recibo el material?',
    a: 'Inmediatamente después de tu pago, en menos de 5 minutos en tu casilla de email.'
  }, {
    q: '¿Qué pasa si no me funciona?',
    a: 'Tenés 7 días de garantía total. Te devolvemos el dinero sin preguntas.'
  }];
  return <section className="w-full py-10 md:py-16 px-4 bg-[#FDF6F0]" data-id="element-42">
      <div className="max-w-3xl mx-auto" data-id="element-43">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-6 md:mb-10 text-brand-text-primary" data-id="element-44">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-3 md:space-y-4" data-id="element-45">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.q} answer={faq.a} data-id="element-46" />)}
        </div>
      </div>
    </section>;
}
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border border-[#E8D8E0] rounded-lg bg-white shadow-sm" data-id="element-47">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full flex justify-between items-center p-4 md:p-5 text-left hover:bg-[#F3E8F0] transition-colors rounded-lg" data-id="element-48">
        <span className="font-semibold text-lg text-brand-text-primary pr-4" data-id="element-49">
          {question}
        </span>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.2
      }} className="flex-shrink-0" data-id="element-50">
          <ChevronDown className="w-5 h-5 text-brand-purple-light" data-id="element-51" />
        </motion.div>
      </button>

      {isOpen && <div className="px-4 md:px-5 pb-4 md:pb-5 pt-2 text-brand-text-body border-t border-[#E8D8E0]" data-id="element-52">
          {answer}
        </div>}
    </div>;
}